import axios from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import { api } from 'services/api';
import { notificationContainer } from 'utils/notificationContainer';
import { TSupersetDashboard } from './types';
import {
	getSupersetDashboardsFailure,
	getSupersetDashboardsRequest,
	getSupersetDashboardsSuccess,
} from './reducer';

function* getSupersetDashboardsWorker() {
	try {
		const response: TSupersetDashboard[] = yield call(api.superset.getSupersetDashboards);
		yield put(getSupersetDashboardsSuccess(response ?? []));
	} catch (error) {
		yield put(getSupersetDashboardsFailure());
		if (axios.isAxiosError(error)) {
			notificationContainer(
				String(error?.response?.data?.message ?? error.message ?? 'Failed to load dashboards'),
				'error',
			);
		}
	}
}

export function* supersetSaga() {
	yield takeLatest(getSupersetDashboardsRequest.type, getSupersetDashboardsWorker);
}
